import { Button, Col, Input, Row, Spin } from 'antd'
import getWebhookDetails from 'api/clients/getWebhookDetails'
import subscribeWebhook from 'api/clients/subscribeWebhook'
import { useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo, useState } from 'react'
import ReactJson from 'react-json-view'
import handleAxiosError from 'utils/handleAxiosError'

const WebhookJSON = () => {
	const { clientProfile } = useAppSelector(state => state.singleClient)
	const [json, setJson] = useState({})
	const [loading, setLoading] = useState(true)
	const [reRender, setRerender] = useState(false)

	const environment: string = process.env.REACT_APP_EDGE_MODE || 'STAGING'

	const URL = useMemo(() => {
		return `	https://${
			environment === 'STAGING'
				? 'webhookstaging.whatcx.com'
				: 'webhook.whatcx.com/'
		}/v1/webhook/pinnacle/${clientProfile?._id}`
	}, [environment, clientProfile])

	const fetchDetails = async () => {
		if (
			clientProfile?.vendorSelected === 'PINNACLE' ||
			clientProfile?.vendorSelected === 'PINNACLE_V3'
		) {
			setLoading(true)
			try {
				const data = await getWebhookDetails(clientProfile._id)
				setJson(data)
			} catch (error: any) {
				handleAxiosError(error)
			} finally {
				setLoading(false)
			}
		}
	}

	const handleSubscribe = async () => {
		if (!clientProfile) return
		setLoading(true)
		try {
			await subscribeWebhook(clientProfile?._id)
		} catch (error: any) {
			handleAxiosError(error)
		} finally {
			setRerender(prev => !prev)
		}
	}
	useEffect(() => {
		fetchDetails()
	}, [reRender])
	return (
		<Spin spinning={loading}>
			<br />
			<Row gutter={10}>
				<Col span={20}>
					<Input value={URL} contentEditable={false} />
				</Col>
				<Col span={4}>
					<Button onClick={handleSubscribe}>Subscribe Webhook</Button>
				</Col>
			</Row>
			<br />
			<ReactJson
				src={json}
				theme='google'
				indentWidth={8}
				style={{
					padding: 16,
					borderRadius: 8,
				}}
			/>
		</Spin>
	)
}

export default WebhookJSON
